// Helper functions
function replaceUrlParam(url, paramName, paramValue) {
  var pattern = new RegExp('('+paramName+'=).*?(&|$)'),
      newUrl = url;
  if (url.search(pattern) >= 0) {
    newUrl = url.replace(pattern,'$1' + paramValue + '$2');
  } else {
    newUrl = newUrl + (newUrl.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
  }
  return newUrl;
}
//  Callback for image loading based on Paul Irish method
$.fn.imagesLoaded = function(callback, fireOne) {
var
  args = arguments,
  elems = this.filter('img'),
  elemsLen = elems.length - 1;
elems
  .bind('load', function(e) {
      if (fireOne) {
          !elemsLen-- && callback.call(elems, e);
      } else {
          callback.call(this, e);
      }
  }).each(function() {
    // cached images don't fire load sometimes, so we reset src.
    if (this.complete || this.complete === undefined){
        this.src = this.src;
    }
  });
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $('body'),

    // Navigation
    $navigation              : $('.accessibleNav'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  }
};

timber.init = function () {
  if(typeof(FastClick) !== 'undefined'){
    FastClick.attach(document.body);
  }
  timber.cacheSelectors();
  timber.accessibleNav();
  // timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};


timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.getHash = function () {
  return window.location.hash;
};

timber.updateHash = function (hash) {
  window.location.hash = '#' + hash;
  $('#' + hash).attr('tabindex', -1).focus();
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector,
      addToCartText = options.addToCartText || "Add to Basket",
      membershipProduct = options.membershipProduct || false;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $buttonPrice = $('#ButtonPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText'),
      $quantityInput = $quantityElements.find('input');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = $('.productImg[data-image-id="'+ variant.featured_image.id +'"]');
      var newPosition = newImg.parent().attr('index');

      // Slider not loaded
      if (newPosition === undefined) {
        return;
      }else {
         $('#ProductPhoto').slickGoTo(newPosition);
      }
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html(addToCartText);
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Not Currently Available ");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    if(membershipProduct) {
      $productPrice.html("<span class='money'>" + Shopify.formatMoney(chargeRabbitFields(variant).amount, moneyFormat) + "</span>" + chargeRabbitFields(variant).interval );
      $buttonPrice.html("<span class='money'>" + Shopify.formatMoney(chargeRabbitFields(variant).amount, moneyFormat) + "</span>" + chargeRabbitFields(variant).interval );
    }
    else {
      $productPrice.html("<span class='money'>" + Shopify.formatMoney(variant.price, moneyFormat) + "</span>");
      if (window.buckscc && typeof window.buckscc.convertPage === 'function') {
        window.buckscc.convertPage();
      }

      var quantity,
      quantityLabel = "";
      if($quantityInput.length)
        quantity = $quantityInput.val();
      else
        quantity = 1;

      if(quantity > 1)
        quantityLabel = "(" + quantity + ")";

      $buttonPrice.attr('data-item-price', variant.price);
      $buttonPrice.attr('data-item-quantity', quantity);
      $buttonPrice.html("<span class='money'>" + Shopify.formatMoney(variant.price * quantity, moneyFormat) + "</span>&nbsp;" + quantityLabel);
    }

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
};

timber.switchZoom = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('data-zoom-image', src);
};

// timber.responsiveVideos = function () {
//   $('iframe[src*="youtube.com/embed"]').wrap('<div class="video-wrapper"></div>');
//   $('iframe[src*="player.vimeo"]').wrap('<div class="video-wrapper"></div>');
// };

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

// Initialize Timber's JS on docready
$(timber.init);



/*============================================================================
    Pipeline Functions  )`-....._,.-'``'-.,_,.='``'-.,
==============================================================================*/

window.pipeline = window.pipeline || {};

pipeline.init = function () {
  pipeline.equalHeight();
  pipeline.navClick();
  pipeline.delayNav();
  pipeline.smoothScroll();
  pipeline.detectNav();
  pipeline.tabletMenu();
  pipeline.fullHeight();
  pipeline.contentOverflow();
};

pipeline.equalHeight = function() {
  var $columns = $('.equalHeightColumn');
  $columns.height('initial');
  var height = 0;
  $columns.each(function () {
    if ($(this).height() > height) {
      height = $(this).height();
    }
  });
  $columns.height(height);
};

pipeline.navClick = function() {
  var selector = '.accessibleNav.mobile-only .grandparent > a.nav-carat, .accessibleNav.mobile-only .grandparent > a.nav-link, .accessibleNav.mobile-only .parent > a.nav-carat, .accessibleNav.mobile-only .parent > a.nav-link';
  $(selector).on('click', function(event){
    event.preventDefault();
    $(this).closest('li').toggleClass('main-menu--expanded');
  });
};

pipeline.delayNav = function() {
  var hoverTimeout;
  var linkRemove;
  $('.grandparent').hover(function() {
    if(typeof linkRemove != "undefined") {
      linkRemove.removeClass('hover');
    }
    window.clearTimeout(hoverTimeout);
    var linkAdd = $(this);
    $( linkAdd ).addClass('hover');
  },function() {
    linkRemove = $(this);
    hoverTimeout = window.setTimeout(function() {
      linkRemove.removeClass('hover');
    },250);
  });
};

pipeline.tabletMenu = function() {

    $('.nav--desktop .grandparent > a.nav-link, .nav--desktop main-menu > .parent > a.nav-link').on( 'click', function(event){
      if ( $(this).parent().hasClass('hover') ){
        $(this).parent().removeClass('hover');
      } else{
        event.preventDefault();
        $('.grandparent, .parent').removeClass('hover');
        $(this).parent().addClass('hover');
      }
    });

};

pipeline.smoothScroll = function() {
  $('a[href*=#]:not([href=#]):not([data-toggle])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        if (location.pathname.includes("formula-pro-advanced")) {
          $('html,body').animate({
            scrollTop: target.offset().top - 100
          }, 1000);
          return false;
        } else {
          $('html,body').animate({
            scrollTop: target.offset().top
          }, 1000);
          return false;
        }
      }
    }
  });
};

pipeline.detectNav = function(){
  var navWidth = $('.nav--desktop .main-menu').outerWidth();
  var logoWidth = $('.logo-wrapper').outerWidth();
  var widthLimit = $('.site-header .wrapper').width();
  var totalWidth = navWidth + logoWidth;
  $('.site-header, .info-bar').addClass('showDesktop');
  // if ( totalWidth < widthLimit){
  //   $('.site-header, .info-bar').addClass('showDesktop');
  //   $('.site-header, .info-bar').removeClass('showMobile');
  // }
  // else {
  //   $('.site-header, .info-bar').addClass('showMobile');
  //   $('.site-header, .info-bar').removeClass('showDesktop');
  // }
};

pipeline.fullHeight = function(){
  var windowHeight = $(window).height();
  var navHeight = ($('.header__wrapper').height());
  var heroHeight = windowHeight - navHeight;
  $('.main-content > .use_screen_full:first-child').height(heroHeight);
  $('.main-content > .use_screen_full:not(:first-child)').height(windowHeight);
};

pipeline.contentOverflow = function(){
  $('.preventOverflow').css('min-height', function() {
    var contentHeight = $(this).find('.preventOverflowContent').height();
    return (contentHeight + 30);
  });
};

pipeline.positionFooterImage = function() {
  var logoHeight = $('#footerLogoImg').height();
  var logoOffset = ( logoHeight/-2 );
  var logoWidth = $('#footerLogoImg').width();
  var logoHorizontalOffset = ( logoWidth/-2 );
  $('#footerLogo').css('top', logoOffset);
  $('#footerLogo').css('margin-left', logoHorizontalOffset);
  $('#footerLogo').css('opacity', '1');
};
$('#footerLogoImg').imagesLoaded(function() {
  pipeline.positionFooterImage();
});

$(window).resize(function() {
  pipeline.detectNav();
  pipeline.equalHeight();
  pipeline.fullHeight();
  pipeline.contentOverflow();
}).resize();

$('.logo-image').imagesLoaded(function() {
  $(window).resize();
});
$(window).load(function(){
  $(window).resize();
});

$(document).ready(function () {
    $('.scrollup').click(function () {
        $("html, body").animate({
            scrollTop: $(".site-footer-wrapper #sign_up").offset().top
        }, 600);
    });



function proAdvanced() {
	jQuery.ajax({
	  	type: 'POST',
	  	url: '/cart/add.js',
	  	data: {
	      	quantity: 1,
	      	id: 6977210581026
	    },
	  	dataType: 'json',
	  	success: function() {
	      	window.location.href = '/checkout';
	    },

	});
}

function instantWarmer() {
	jQuery.ajax({
	  	type: 'POST',
	  	url: '/cart/add.js',
	  	data: {
	      	quantity: 1,
	      	id: 28912612212770
	    },
	  	dataType: 'json',
	  	success: function() {
	      	window.location.href = '/checkout';
	    },

	});
}

function sterilizeDryer() {
	jQuery.ajax({
	  	type: 'POST',
	  	url: '/cart/add.js',
	  	data: {
	      	quantity: 1,
	      	id: 42855728206
	    },
	  	dataType: 'json',
	  	success: function() {
	      	window.location.href = '/checkout';
	    },

	});
}

function babyBottles() {
	jQuery.ajax({
	  	type: 'POST',
	  	url: '/cart/add.js',
	  	data: {
	      	quantity: 1,
	      	id: 27801905731
	    },
	  	dataType: 'json',
	  	success: function() {
	      	window.location.href = '/checkout';
	    },

	});
}


function makeFood() {
	jQuery.ajax({
	  	type: 'POST',
	  	url: '/cart/add.js',
	  	data: {
	      	quantity: 1,
	      	id: 42855718478
	    },
	  	dataType: 'json',
	  	success: function() {
	      	window.location.href = '/checkout';
	    },

	});
}

//time savings calculator 3/19/2020 A2 Creative

    //minute savings per bottle
    var time_multiplier = '';
    var data_id = '';

    $( ".goToStep2" ).on( "click", function(e) {
      //$("body").delegate(".goToStep2", "click", function(){
   		e.preventDefault();
       var data_step = $(this).attr('data-step');
       var data_id = $('.step').attr('data-id', '2');

      //add different savings for different products
      if (data_step == 'make-a-bottle'){
        time_multiplier = 4;
        $('.box2 .inner h2').html('STEP 2: TELL US HOW MANY BOTTLES YOU MAKE A DAY');
        $( ".box2 .goToStep3 img" ).each(function() {
          $( this ).attr('src','https://cdn.shopify.com/s/files/1/1465/2384/files/babybottle.png?v=1584666647');
        });
        $('.result .img img').attr("src","https://cdn.shopify.com/s/files/1/1465/2384/files/M-BW-IMAGE-4.png?v=1585246603");
        $('.result .content p').html('<strong>SAVE 4 MINUTES per bottle and <span id="minute-savings">30</span> MINUTES a day</strong> using the Baby Brezza Formula Pro Advanced!');
        $('.inline-reviews').attr("data-bv-product-id", "553111519266");
        $('.result .content ul li:first-child').html('Automatically makes a warm formula bottle instantly versus 5+ minutes by hand');
        $('.result .content ul li:nth-child(2)').html('Customizes your bottle by temperature and ounce. Even make a water only bottle');
        $('.result .content ul li:nth-child(3)').html('Moms love it! <span>★★★★★</span> Life Changer!” Baileylynn, Manning, Iowa ');
        $('.result .content ul li.last-child').css('display', 'none');
        $('.result .content .btn-grid .btn-1').attr("href", "https://www.youtube.com/watch?v=KVCJ-If5XSg");
        $('.result .content .btn-grid .btn-2').attr("href", "/products/formula-pro-advanced");
        $('.inline-reviews').attr("data-bv-redirect-url", "/products/formula-pro-advanced#reviews");
        //$('.result .content .btn-grid .btn-3').attr("href", proAdvanced );
        $( ".result .content .btn-grid .btn-3" ).click(function() {
          proAdvanced();
        });
        $('.last-item').css('display', 'none');
      }
      if (data_step == 'warm-a-bottle'){
        time_multiplier = 3;
        $('.box2 .inner h2').html('STEP 2: TELL US HOW MANY BOTTLES YOU MAKE A DAY');
        $( ".box2 .goToStep3 img" ).each(function() {
          $( this ).attr('src','https://cdn.shopify.com/s/files/1/1465/2384/files/babybottle.png?v=1584666647');
        });
        $('.last-item').css('display', 'none');
        $('.result .img img').attr("src","https://cdn.shopify.com/s/files/1/1465/2384/files/instant-warmer-calc.png?v=1586445605");
        $('.result .content p').html('<strong>SAVE 3 MINUTES per bottle and <span id="minute-savings">30</span> MINUTES a day</strong> using the Baby Brezza Instant Warmer!');
        $('.inline-reviews').attr("data-bv-product-id", "3774180425762");
        $('.result .content ul li:first-child').html('Instantly make a warm formula bottle by dispensing warm water 24/7');
        $('.result .content ul li:nth-child(2)').html('No more waiting 4+ minutes for a traditional bottle warmer to warm up a bottle');
        $('.result .content ul li:nth-child(3)').html('Moms love it! <span>★★★★★</span> “Simple, Best Bottle Warmer!”, CLKobernick, Flushing, NY');
        $('.result .content ul li.last-child').css('display', 'none');
        $('.result .content .btn-grid .btn-1').attr("href", "https://www.youtube.com/watch?v=5ze5iMM2w8Q");
        $('.result .content .btn-grid .btn-2').attr("href", "/products/instant-warmer");
        $( ".result .content .btn-grid .btn-3" ).click(function() {
          instantWarmer();
        });
        $('.inline-reviews').attr("data-bv-redirect-url", "/products/instant-warmer#reviews");
      }
      if (data_step == 'sterilize-bottle'){
        time_multiplier = 5;
        $('.box2 .inner h2').html('Step 2: How many times do you sterilize bottles or pump parts a week?');
        $( ".box2 .goToStep3 img" ).each(function() {
          $( this ).attr('src','https://cdn.shopify.com/s/files/1/1465/2384/files/babybottle.png?v=1584666647');
        });
        $('.last-item').css('display', 'block');
        $('.result .img img').attr("src","https://cdn.shopify.com/s/files/1/1465/2384/files/STERIDRY.png?v=1585246606");
        $('.result .content p').html('<strong>SAVE 5 MINUTES per bottle and <span id="minute-savings">30</span> MINUTES a week</strong> using the Baby Brezza One Step Sterilizer Dryer!');
        //$('.inline-reviews').attr("data-bv-product-id", "9109738254");
        $('.result .content ul li:first-child').html('Automatically sterilizes & dries bottles, pump parts and other accessories. ');
        $('.result .content ul li:nth-child(2)').html('No more boiling and then air drying on a non-sterilize drying rack which is time consuming and undermines sterilization');
        $('.result .content ul li:nth-child(3)').html('Natural steam kills 99.9% of germs');
        if ($('.result .content ul li.last-child').length){

        }else {
        	$('.result .content ul').append('<li class="last-child">Moms love it! <span>★★★★★</span> “My Best Baby Item”, Wigginc, Greenville, TN</li>');
        }
        $('.result .content .btn-grid .btn-1').attr("href", "https://www.youtube.com/watch?v=D7TIqW7-od8");
        $('.result .content .btn-grid .btn-2').attr("href", "/products/one-step-sterilizer-dryer");
		$( ".result .content .btn-grid .btn-3" ).click(function() {
          sterilizeDryer();
        });
		//$('.inline-reviews').attr("data-bv-redirect-url", "/products/one-step-sterilizer-dryer#reviews");
      }
      if (data_step == 'handwash-bottle'){
        time_multiplier = 1;
        $('.box2 .inner h2').html('STEP 2: TELL US HOW MANY BOTTLES YOU MAKE A DAY');
        $( ".box2 .goToStep3 img" ).each(function() {
          $( this ).attr('src','https://cdn.shopify.com/s/files/1/1465/2384/files/babybottle.png?v=1584666647');
        });
        $('.last-item').css('display', 'none');
        $('.result .img img').attr("src","https://cdn.shopify.com/s/files/1/1465/2384/files/baby-single.png?v=1586445426");
        $('.result .content p').html('<strong>SAVE 1 MINUTE per bottle and <span id="minute-savings">30</span> MINUTES a day</strong> using Baby Brezza Natural Bottles!');
        $('.result .content ul li:first-child').html('Automatically sterilizes & dries bottles, pump parts and other accessories. ');
        $('.inline-reviews').attr("data-bv-product-id", "9160493518");
        $('.result .content ul li:first-child').html('Easiest to clean with only 2 parts and ultra-wide – less to clean and less time to assemble');
        $('.result .content ul li:nth-child(2)').html('Breast-like nipples for easy transition between breast & bottle plus anti-colic TruFLo™ vent');
        $('.result .content ul li:nth-child(3)').html('Moms love it! <span>★★★★★</span> “Favorite Bottle!”, Geori08');
        $('.result .content ul li.last-child').css('display', 'none');
        $('.result .content .btn-grid .btn-1').attr("href", "https://www.youtube.com/watch?v=D2lxC30wxIM");
        $('.result .content .btn-grid .btn-2').attr("href", "/products/baby-brezza-bottle-9oz");
		$( ".result .content .btn-grid .btn-3" ).click(function() {
          babyBottles();
        });
        //$('.inline-reviews').attr("data-bv-redirect-url", "/products/5-oz-natural-baby-bottle-3-pack#reviews");
      }
      if (data_step == 'make-food'){
        time_multiplier = 2;
        $('.box2 .inner h2').html('STEP 2: HOW MANY TIMES PER WEEK DO YOU MAKE HOMEMADE BABY FOOD?');
        $( ".box2 .goToStep3 img" ).each(function() {
          $( this ).attr('src','https://cdn.shopify.com/s/files/1/1465/2384/files/baby-food_65566375-8de1-48c6-8a51-4da98256967c.png?v=1586445084');
        });
        $('.last-item').css('display', 'none');
        $('.result .img img').attr("src","https://cdn.shopify.com/s/files/1/1465/2384/files/FOOD_MAKER_DELUXE.png?v=1585246607");
        $('.result .content p').html('<strong>SAVE 2 MINUTES per batch and <span id="minute-savings">30</span> MINUTES a week</strong> using the Baby Brezza One Step Food Maker Deluxe!');
        $('.inline-reviews').attr("data-bv-product-id", "9160898254");
        $('.result .content ul li:first-child').html('Automatically steams & blends baby food in 1 easy step! Just press 1 button to make a puree! ');
        $('.result .content ul li:nth-child(2)').html('Make homemade baby food in as little as 10 minutes');
		$('.result .content ul li:nth-child(3)').html('Moms love it! <span>★★★★★</span> “Easy, Fast, Simple!”, Sam2140, Sugar Land, TX ');
        $('.result .content ul li.last-child').css('display', 'none');
        $('.result .content .btn-grid .btn-1').attr("href", "https://www.youtube.com/watch?v=BVaQjnQRjis");
        $('.result .content .btn-grid .btn-2').attr("href", "/products/one-step-baby-food-maker-deluxe");
		$( ".result .content .btn-grid .btn-3" ).click(function() {
          makeFood();
        });
        //$('.inline-reviews').attr("data-bv-redirect-url", "/products/one-step-baby-food-maker-deluxe#reviews");
      }

      step2();
    });
    $( ".goToStep3" ).click(function(e) {
      var bottle_amount = $(this).attr('data-id');
      console.log('minute savings', time_multiplier);
      console.log('bottle amount', bottle_amount);
      var total_savings = bottle_amount * time_multiplier
      var data_id = $('.step').attr('data-id', '3');
      $('#minute-savings').html(total_savings);

        step3();
    });
    $( ".backToStep2" ).click(function(e) {
        backstep2();
        var data_id = $('.step').attr('data-id', '2');
    });
    $( ".backToStep1" ).click(function(e) {
        backstep1();
        var data_id = $('.step').attr('data-id', '1');
    });
    $( ".backToStart" ).click(function(e) {
        backToStart();
        var data_id = $('.step').attr('data-id', '1');
    });




    function step2(){ // inner stuff slides left
        var initalLeftMargin = $( ".innerLiner" ).css('margin-left').replace("px", "")*1;
        var container_width = $( ".savings-calc-container" ).outerWidth();
        //console.log("innerLiner css", initalLeftMargin);
        //console.log("container width", container_width);
        var newLeftMargin = (initalLeftMargin - container_width); // extra 2 for border
        var newWidth = Math.abs(newLeftMargin);
        //var step_width = $('.step').css('max-width', newLeftMargin);
        //$( ".step" ).animate({maxWidth: newLeftMargin}, 500);
        $( ".innerLiner" ).animate({marginLeft: newLeftMargin}, 500);
        $(".step").css("max-width", container_width);
        var step_height = $('.step-2').outerHeight(true );
  		$('.innerLiner').css('height', step_height)
    }
    function step3(){ // inner stuff slides left
        var initalLeftMargin = $( ".innerLiner" ).css('margin-left').replace("px", "")*1;
        var container_width = $( ".savings-calc-container" ).outerWidth();
        //console.log("innerLiner css", initalLeftMargin);
        //console.log("container width", container_width);
        var newLeftMargin = (initalLeftMargin - container_width); // extra 2 for border
        //var step_width = $('.step').css('max-width', newLeftMargin);
        //$( ".step" ).animate({maxWidth: newLeftMargin}, 500);
        $( ".innerLiner" ).animate({marginLeft: newLeftMargin}, 500);
        $('html, body').animate({
        	scrollTop: $('.innerLiner').offset().top - 100 //#DIV_ID is an example. Use the id of your destination on the page
        }, 'slow');
        $(".step").css("max-width", container_width);
        $(".step .inner").css("max-width", container_width);
        var step_height = $('.step-3').outerHeight(true );
  		$('.innerLiner').css('height', step_height)
    }
    function backstep2(){ // inner stuff slides right
        var initalLeftMargin = $( ".innerLiner" ).css('margin-left').replace("px", "")*1;
        var container_width = $( ".savings-calc-container" ).outerWidth();
        //console.log("innerLiner css", initalLeftMargin);
        //console.log("container width", container_width);
        var newLeftMargin = (initalLeftMargin + container_width); // extra 2 for border
        $( ".innerLiner" ).animate({marginLeft: newLeftMargin}, 500);
        $(".step").css("max-width", container_width);
        var step_height = $('.step-2').outerHeight(true);
  		$('.innerLiner').css('height', step_height)
        console.log(step_height);
    }
    function backstep1(){ // inner stuff slides right
        var initalLeftMargin = $( ".innerLiner" ).css('margin-left').replace("px", "")*1;
        var container_width = $( ".savings-calc-container" ).outerWidth();
        //console.log("innerLiner css", initalLeftMargin);
        //console.log("container width", container_width);
        var newLeftMargin = (initalLeftMargin + container_width); // extra 2 for border
        $( ".innerLiner" ).animate({marginLeft: newLeftMargin}, 500);
        $(".step").css("max-width", container_width);
        var step_height = $('.step-1').outerHeight(true );
  		$('.innerLiner').css('height', step_height)
    }
    function backToStart(){ // inner stuff slides right
        var initalLeftMargin = $( ".innerLiner" ).css('margin-left').replace("px", "")*2;
        var container_width = $( ".savings-calc-container" ).outerWidth();
        //console.log("innerLiner css", initalLeftMargin);
        //console.log("container width", container_width);
        var newLeftMargin = (initalLeftMargin + container_width); // extra 2 for border
        $( ".innerLiner" ).animate({marginLeft: '0px'}, 500);
        $(".step").css("max-width", container_width);
        var step_height = $('.step-1').outerHeight(true);
  		$('.innerLiner').css('height', step_height)
    }

    //video popup on savings caluclator final step
  	$('.popup-youtube, .popup-vimeo').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });
  setTimeout(function(){

    var step_height = $('.step-1').outerHeight();
    $('.innerLiner').css('height', step_height);
    console.log('outer height', step_height);

  }, 3000);


});


$(window).on('load', function () {
    $( window ).resize(function() {
      var initalLeftMargin = $( ".innerLiner" ).css('margin-left').replace("px", "")*1;
      var container_width = $( ".savings-calc-container" ).outerWidth();
      var newLeftMargin = (initalLeftMargin - container_width); // extra 2 for border
      var innerLiner_margin = $( ".innerLiner" ).css('margin-left');
      var data_id = $( ".step" ).attr('data-id');
      var step_height = $('.step').outerHeight(true);
      $('.innerLiner').css('height', step_height);
      //add a data-id number to each "step", and then do an if/else on those numbers. for 2, multiply the width by 2, and then 3.
      if (data_id == '1'){
        console.log('first_section');
      }else if (data_id == '2') {
      	console.log('second_section');
        $( ".innerLiner" ).css('margin-left', -container_width);
      }else if (data_id == '3') {
        console.log('third_section');
        var current_width= $( ".innerLiner" ).css('margin-left');
		console.log('current', current_width);
        console.log('container', container_width);
         $( ".innerLiner" ).css('margin-left', -container_width * 2);
        /*if (container_width < 1500){
          console.log('less than ')
          $( ".innerLiner" ).css('margin-left', -container_width * 2);
        }*/
      }
      $(".step").css("max-width", container_width);
      $(".step .inner").css("max-width", container_width);
    });
  });



// we'll make sure quantity is no more than inventory

window.addEventListener('input', function(e) {
  var theTarget = e.target;
  // console.log({theTarget})
  //check for [max], or get out
  if (theTarget.closest('[max]') === null) return;
  var max = parseInt(theTarget.getAttribute('max'), 10);
  var value = parseInt(theTarget.value, 10) || 0;
  //console.log({max}, {value})
  if (value > max) {
    //alert('We only have ' + max + ' of this item in stock');
    theTarget.value = max;
  }
});



$(pipeline.init);


/* Baby Brezza PDP single-variant title safeguard */
(function () {
  function cleanDefaultVariantTitle() {
    var headings = document.querySelectorAll('h1.product-title');
    headings.forEach(function (heading) {
      heading.textContent = (heading.textContent || '').replace(/\s*-\s*Default Title\s*$/i, '').trim();
    });
  }

  cleanDefaultVariantTitle();
  document.addEventListener('DOMContentLoaded', cleanDefaultVariantTitle);
  window.addEventListener('load', cleanDefaultVariantTitle);
  setTimeout(cleanDefaultVariantTitle, 150);
  setTimeout(cleanDefaultVariantTitle, 600);
  setTimeout(cleanDefaultVariantTitle, 1400);
})();

/* Baby Brezza Formula Prep collection FPA color-card fallback */
(function () {
  var variantCardsLoaded = false;

  function isFormulaPrepCollection() {
    return /\/collections\/formula-prep\/?$/.test(window.location.pathname || '');
  }

  function fpaVariantUrl(variant) {
    return '/products/formula-pro-advanced?variant=' + variant.id;
  }

  function formatAed(cents) {
    var value = (parseInt(cents, 10) || 0) / 100;
    return 'AED ' + value.toLocaleString('en-US', {
      minimumFractionDigits: value % 1 ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  function ensureFormulaPrepCollectionStyles() {
    if (document.getElementById('bbf-formula-prep-mobile-grid-style')) return;
    var style = document.createElement('style');
    style.id = 'bbf-formula-prep-mobile-grid-style';
    style.textContent = [
      '.product-slider .bbf-collection-card-price{color:#63799D;font-size:17px;font-weight:700;line-height:1.2;margin:0 0 10px;text-align:center;}',
      '.product-slider .bbf-collection-card-compare{color:#8a8a8a;display:inline-block;font-size:14px;font-weight:500;margin-left:6px;text-decoration:line-through;}',
      '@media screen and (max-width:767px){.product-slider{padding:18px 14px 24px!important}.product-slider h2{font-size:30px!important;line-height:36px!important;margin-bottom:18px!important}.product-slider .slider{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:18px 12px!important}.product-slider .slider .slide-block{width:100%!important;margin-right:0!important}.product-slider .slick-track,.product-slider .slick-list{display:block!important;width:100%!important;transform:none!important}.product-slider .slick-arrow{display:none!important}.product-slider .slide-block .slide-text{padding-bottom:48px!important}.product-slider .slide-block .slide-text h3{font-size:15px!important;min-height:36px!important}.product-slider .slide-block .slide-text .subtitle{display:none!important}.product-slider .slide-block .slide-text ul{display:block!important;margin:8px 0 0!important;padding-left:0!important;list-style:none!important}.product-slider .slide-block .slide-text ul li{display:flex!important;align-items:flex-start!important;gap:5px!important;padding-left:0!important;margin-bottom:5px!important;color:#111!important;font-size:11px!important;line-height:1.25!important}.product-slider .slide-block .slide-text ul li:before{position:static!important;flex:0 0 auto!important;color:#111!important;font-size:12px!important;line-height:1.2!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function cardHasAnyLink(card, needles) {
    var links = card ? card.querySelectorAll('a[href]') : [];
    for (var i = 0; i < links.length; i += 1) {
      var href = links[i].getAttribute('href') || '';
      for (var j = 0; j < needles.length; j += 1) {
        if (href.indexOf(needles[j]) !== -1) return true;
      }
    }
    return false;
  }

  function updateCardForVariant(card, variant) {
    var title = 'Formula Pro Advanced - ' + variant.title;
    var image = variant.featured_image && variant.featured_image.src;
    card.classList.add('bbf-fpa-color-card');
    card.setAttribute('data-bbf-color', String(variant.title || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''));

    var imageWrap = card.querySelector('.content-wrapper');
    if (imageWrap && image) {
      imageWrap.style.background = 'url(' + image + ')';
    }

    var hiddenImg = card.querySelector('img.tif-visually-hidden');
    if (hiddenImg) hiddenImg.setAttribute('alt', title);

    var heading = card.querySelector('.slide-text h3');
    if (heading) heading.innerHTML = '<u>' + title + '</u>';

    var price = card.querySelector('.bbf-collection-card-price');
    if (!price) {
      price = document.createElement('p');
      price.className = 'bbf-collection-card-price';
      if (heading && heading.parentNode) {
        var subtitle = card.querySelector('.slide-text .subtitle');
        heading.parentNode.insertBefore(price, subtitle ? subtitle.nextSibling : heading.nextSibling);
      }
    }
    if (price) {
      price.innerHTML = '<span class="money">' + formatAed(variant.price) + '</span>' +
        (variant.compare_at_price && variant.compare_at_price > variant.price
          ? ' <span class="bbf-collection-card-compare money">' + formatAed(variant.compare_at_price) + '</span>'
          : '');
    }

    var links = card.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i += 1) {
      links[i].setAttribute('href', fpaVariantUrl(variant));
      var hidden = links[i].querySelector('.tif-visually-hidden');
      if (hidden) hidden.textContent = title + ' ';
    }
  }

  function reinitFormulaPrepSlider(slider) {
    if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) return;
    var isRTL = document.documentElement.dir === 'rtl';
    jQuery(slider).slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      focusOnSelect: true,
      draggable: true,
      swipeToSlide: true,
      rtl: isRTL,
      responsive: [
        { breakpoint: 768, settings: { slidesToShow: 2 } },
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 1400, settings: { slidesToShow: 4 } }
      ]
    });
  }

  function applyColorCardsToContainer(container, variants) {
    if (!container) return false;

    var wasSlick = window.jQuery && jQuery(container).hasClass('slick-initialized') && jQuery.fn && jQuery.fn.slick;
    if (wasSlick) {
      jQuery(container).slick('unslick');
    }

    var cards = Array.prototype.slice.call(container.querySelectorAll(':scope > .slide-block'));
    var whiteCard = null;
    for (var i = 0; i < cards.length; i += 1) {
      if (cardHasAnyLink(cards[i], ['/products/formula-pro-advanced']) && !cardHasAnyLink(cards[i], ['?variant='])) {
        whiteCard = cards[i];
        break;
      }
    }
    if (!whiteCard) {
      if (wasSlick) reinitFormulaPrepSlider(container);
      return false;
    }

    for (var r = cards.length - 1; r >= 0; r -= 1) {
      if (cardHasAnyLink(cards[r], [
        '/products/formula-pro-advanced-premium-black',
        '/products/formula-pro-advanced-baby-formula-dispenser-oatmeal'
      ])) {
        cards[r].parentNode.removeChild(cards[r]);
      }
    }

    var fragment = document.createDocumentFragment();
    for (var v = 0; v < variants.length; v += 1) {
      var clone = whiteCard.cloneNode(true);
      updateCardForVariant(clone, variants[v]);
      fragment.appendChild(clone);
    }
    whiteCard.parentNode.insertBefore(fragment, whiteCard);
    whiteCard.parentNode.removeChild(whiteCard);

    if (wasSlick) reinitFormulaPrepSlider(container);
    return true;
  }

  function bbfFormulaPrepColorCardsFallback() {
    if (variantCardsLoaded || !isFormulaPrepCollection()) return;
    ensureFormulaPrepCollectionStyles();
    if (document.querySelector('.product-slider .bbf-fpa-color-card')) {
      variantCardsLoaded = true;
      return;
    }
    if (!window.fetch) return;

    fetch('/products/formula-pro-advanced.js')
      .then(function (response) { return response.json(); })
      .then(function (product) {
        var variants = (product.variants || []).filter(function (variant) {
          return variant && variant.title && variant.title !== 'Default Title';
        });
        if (!variants.length) return;

        var changed = false;
        changed = applyColorCardsToContainer(document.querySelector('.product-slider .slider'), variants) || changed;
        changed = applyColorCardsToContainer(document.querySelector('.product-slider .stack'), variants) || changed;
        variantCardsLoaded = changed;
      })
      .catch(function () {});
  }

  bbfFormulaPrepColorCardsFallback();
  document.addEventListener('DOMContentLoaded', bbfFormulaPrepColorCardsFallback);
  window.addEventListener('load', bbfFormulaPrepColorCardsFallback);
  setTimeout(bbfFormulaPrepColorCardsFallback, 250);
  setTimeout(bbfFormulaPrepColorCardsFallback, 1000);
})();

/* Baby Brezza Sterilizers collection SuperQuick fallback */
(function () {
  var applied = false;

  function isSterilizersCollection() {
    return /\/collections\/(sterilizer-dryer|bottle-cleaning)\/?$/.test(window.location.pathname || '');
  }

  function ensureStyles() {
    if (document.getElementById('bbf-sterilizers-mobile-grid-style')) return;
    var style = document.createElement('style');
    style.id = 'bbf-sterilizers-mobile-grid-style';
    style.textContent = [
      '.product-slider .bbf-collection-card-price{color:#63799D;font-size:17px;font-weight:700;line-height:1.2;margin:0 0 10px;text-align:center;}',
      '.product-slider .bbf-collection-card-compare{color:#8a8a8a;display:inline-block;font-size:14px;font-weight:500;margin-left:6px;text-decoration:line-through;}',
      '@media screen and (max-width:767px){.product-slider{padding:18px 14px 24px!important}.product-slider h2{font-size:30px!important;line-height:36px!important;margin-bottom:18px!important}.product-slider .slider{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:18px 12px!important}.product-slider .slider .slide-block{width:100%!important;margin-right:0!important}.product-slider .slick-track,.product-slider .slick-list{display:block!important;width:100%!important;transform:none!important}.product-slider .slick-arrow{display:none!important}.product-slider .slide-block .slide-text{padding-bottom:48px!important}.product-slider .slide-block .slide-text h3{font-size:15px!important;min-height:36px!important}.product-slider .slide-block .slide-text .subtitle{display:none!important}.product-slider .slide-block .slide-text ul{display:block!important;margin:8px 0 0!important;padding-left:0!important;list-style:none!important}.product-slider .slide-block .slide-text ul li{display:flex!important;align-items:flex-start!important;gap:5px!important;padding-left:0!important;margin-bottom:5px!important;color:#111!important;font-size:11px!important;line-height:1.25!important}.product-slider .slide-block .slide-text ul li:before{position:static!important;flex:0 0 auto!important;color:#111!important;font-size:12px!important;line-height:1.2!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function formatAed(cents) {
    var value = (parseInt(cents, 10) || 0) / 100;
    return 'AED ' + value.toLocaleString('en-US', {
      minimumFractionDigits: value % 1 ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  function updateCard(card, product, title, features) {
    if (!card || !product) return;
    var image = product.featured_image || (product.images && product.images[0]);
    var variant = product.variants && product.variants[0];
    var imageWrap = card.querySelector('.content-wrapper');
    if (imageWrap && image) imageWrap.style.background = 'url(' + image + ')';

    var hiddenImg = card.querySelector('img.tif-visually-hidden');
    if (hiddenImg) hiddenImg.setAttribute('alt', title);

    var heading = card.querySelector('.slide-text h3');
    if (heading) heading.textContent = title;

    var subtitle = card.querySelector('.slide-text .subtitle');
    if (subtitle) subtitle.textContent = 'Sterilises & dries in just 10 minutes';

    var price = card.querySelector('.bbf-collection-card-price');
    if (!price) {
      price = document.createElement('p');
      price.className = 'bbf-collection-card-price';
      var anchor = subtitle || heading;
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(price, anchor.nextSibling);
    }
    if (price && variant) {
      price.innerHTML = '<span class="money">' + formatAed(variant.price) + '</span>' +
        (variant.compare_at_price && variant.compare_at_price > variant.price
          ? ' <span class="bbf-collection-card-compare money">' + formatAed(variant.compare_at_price) + '</span>'
          : '');
    }

    var list = card.querySelector('.slide-text ul');
    if (list) list.innerHTML = features;

    var links = card.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i += 1) {
      links[i].setAttribute('href', product.url);
      var hidden = links[i].querySelector('.tif-visually-hidden');
      if (hidden) hidden.textContent = title + ' ';
    }
  }

  function unslickMobile(slider) {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    if (window.jQuery && jQuery.fn && jQuery.fn.slick && jQuery(slider).hasClass('slick-initialized')) {
      jQuery(slider).slick('unslick');
    }
  }

  function applyFallback() {
    if (applied || !isSterilizersCollection()) return;
    ensureStyles();
    var slider = document.querySelector('.product-slider .slider');
    if (!slider || !window.fetch) return;
    unslickMobile(slider);

    Promise.all([
      fetch('/products/superquick™-baby-bottle-sterilizer-and-dryer-sterilizes-dries-in-just-10-minutes.js').then(function (response) { return response.json(); }),
      fetch('/products/superquick-steriliser-dryer-premium-black.js').then(function (response) { return response.json(); })
    ]).then(function (products) {
      var cards = Array.prototype.slice.call(slider.querySelectorAll(':scope > .slide-block'));
      var stainlessCard = null;
      for (var i = 0; i < cards.length; i += 1) {
        var link = cards[i].querySelector('a[href*="superquick™-baby-bottle-sterilizer-and-dryer-sterilizes-dries-in-just-10-minutes"],a[href*="superfast-sterilizer-dryer-only-10-minutes-to-sterilize-dry"]');
        if (link) {
          stainlessCard = cards[i];
          break;
        }
      }
      if (!stainlessCard) return;

      updateCard(stainlessCard, products[0], 'SuperQuick Steriliser Dryer - Stainless Steel', '<li>Sterilises and dries in just 10 minutes!</li><li>Natural steam kills 99.9% of germs</li><li>Holds 6 bottles &amp; 2 pump part sets</li><li>Premium stainless steel finish</li>');

      if (!slider.querySelector('a[href*="superquick-steriliser-dryer-premium-black"]')) {
        var blackCard = stainlessCard.cloneNode(true);
        updateCard(blackCard, products[1], 'SuperQuick Steriliser Dryer - Premium Black', '<li>Website-only color</li><li>Sterilises and dries in just 10 minutes!</li><li>Natural steam kills 99.9% of germs</li><li>Holds 6 bottles &amp; 2 pump part sets</li>');
        stainlessCard.parentNode.insertBefore(blackCard, stainlessCard.nextSibling);
      }

      applied = true;
      unslickMobile(slider);
    }).catch(function () {});
  }

  applyFallback();
  document.addEventListener('DOMContentLoaded', applyFallback);
  window.addEventListener('load', applyFallback);
  setTimeout(applyFallback, 250);
  setTimeout(applyFallback, 1000);
})();

// SuperQuick cached compare price fallback
(function () {
  function applySuperQuickComparePriceFallback() {
    var body = document.body;
    if (!body || !/^superquick/i.test(body.id || "")) return;
    if (!document.getElementById("bbf-superquick-compare-price-fallback")) {
      var style = document.createElement("style");
      style.id = "bbf-superquick-compare-price-fallback";
      style.textContent = [
        "@media (max-width: 768px) {",
        "body.template-product[id^='superquick'] .product-title-container .product__price.on-sale{display:flex!important;flex-wrap:wrap!important;align-items:baseline!important;gap:2px 0!important;max-width:100%!important;overflow:visible!important;}",
        "body.template-product[id^='superquick'] .product-title-container .product__price.on-sale #ProductPrice,body.template-product[id^='superquick'] .product-title-container .product__price.on-sale #ProductPrice .money,body.template-product[id^='superquick'] .product-title-container .product__price.on-sale #ProductPrice .buckscc-money{color:#111!important;font-size:30px!important;line-height:1.05!important;font-weight:800!important;text-decoration:none!important;white-space:nowrap!important;}",
        "body.template-product[id^='superquick'] .product-title-container .product__price.on-sale .compare-at{flex:0 0 100%!important;display:block!important;width:100%!important;max-width:100%!important;margin:-2px 0 0!important;padding:0!important;}",
        "body.template-product[id^='superquick'] .product-title-container .product__price.on-sale .compare-at,body.template-product[id^='superquick'] .product-title-container .product__price.on-sale .compare-at *,body.template-product[id^='superquick'] .product-title-container .product__price.on-sale .compare-at .money,body.template-product[id^='superquick'] .product-title-container .product__price.on-sale .compare-at .buckscc-money,body.template-product[id^='superquick'] .product-title-container .product__price.on-sale .compare-at #ComparePrice,body.template-product[id^='superquick'] .product-title-container .product__price.on-sale .compare-at #ComparePrice *{color:#8a8f98!important;font-size:16px!important;line-height:1.1!important;font-weight:700!important;text-decoration:line-through!important;text-decoration-thickness:1.5px!important;text-decoration-color:currentColor!important;white-space:nowrap!important;}",
        "}"
      ].join("");
      document.head.appendChild(style);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applySuperQuickComparePriceFallback);
  } else {
    applySuperQuickComparePriceFallback();
  }
  window.addEventListener("load", applySuperQuickComparePriceFallback);
  setTimeout(applySuperQuickComparePriceFallback, 1200);
})();

/* Baby Brezza Bottle Warming mobile grid fallback */
(function () {
  var applied = false;
  var productMap = {
    'portable-bottle-warmer': {
      title: 'SuperFast Portable Warmer - Rechargeable',
      subtitle: 'Warm bottles anywhere',
      features: '<li>Warms formula or breast milk on the go</li><li>Rechargeable and travel-ready</li><li>Fast warming without water</li><li>Works with most bottle brands</li>'
    },
    'safe-smart-baby-bottle-warmer': {
      title: 'Safe + Smart Bottle Warmer',
      subtitle: 'Bluetooth smart warming',
      features: '<li>Bluetooth control from your phone</li><li>Safely warms breast milk and formula</li><li>Steady warm water bath technology</li><li>Fits most bottle types</li>'
    },
    'instant-warmer': {
      title: 'Instant Warmer',
      subtitle: 'Instant warm water for bottles',
      features: '<li>Dispenses warm water instantly</li><li>Three temperature settings</li><li>Airtight tank keeps water fresh</li><li>Perfect for faster formula bottles</li>'
    },
    'superfast-portable-warmer-instant-water-warmer-bundle': {
      title: 'Portable Warmer + Instant Warmer Bundle',
      subtitle: 'Warm bottles at home or on the go',
      features: '<li>Includes SuperFast Portable Warmer</li><li>Includes Instant Water Warmer</li><li>Warm bottles at home or while travelling</li><li>Bundle value with both warming essentials</li>'
    }
  };

  function isBottleWarmingCollection() {
    return /\/collections\/bottle-warming\/?$/.test(window.location.pathname || '');
  }

  function ensureStyles() {
    if (document.getElementById('bbf-bottle-warming-mobile-grid-style')) return;
    var style = document.createElement('style');
    style.id = 'bbf-bottle-warming-mobile-grid-style';
    style.textContent = [
      '.product-slider .bbf-collection-card-price{color:#63799D;font-size:17px;font-weight:700;line-height:1.2;margin:0 0 10px;text-align:center;}',
      '.product-slider .bbf-collection-card-compare{color:#8a8a8a;display:inline-block;font-size:14px;font-weight:500;margin-left:6px;text-decoration:line-through;}',
      '@media screen and (max-width:767px){.product-slider{padding:18px 14px 24px!important}.product-slider h2{font-size:30px!important;line-height:36px!important;margin-bottom:18px!important}.product-slider .slider{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:18px 12px!important}.product-slider .slider .slide-block{width:100%!important;margin-right:0!important}.product-slider .slick-track,.product-slider .slick-list{display:block!important;width:100%!important;transform:none!important}.product-slider .slick-arrow{display:none!important}.product-slider .slide-block .slide-text{padding-bottom:48px!important}.product-slider .slide-block .slide-text h3{font-size:15px!important;min-height:36px!important}.product-slider .slide-block .slide-text .subtitle{display:none!important}.product-slider .slide-block .slide-text ul{display:block!important;margin:8px 0 0!important;padding-left:0!important;list-style:none!important}.product-slider .slide-block .slide-text ul li{display:flex!important;align-items:flex-start!important;gap:5px!important;padding-left:0!important;margin-bottom:5px!important;color:#111!important;font-size:11px!important;line-height:1.25!important}.product-slider .slide-block .slide-text ul li:before{position:static!important;flex:0 0 auto!important;color:#111!important;font-size:12px!important;line-height:1.2!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function formatDhs(cents) {
    var value = (parseInt(cents, 10) || 0) / 100;
    return 'DHS. ' + value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function findCard(slider, handle) {
    return slider.querySelector(':scope > .slide-block a[href*="' + handle + '"]')?.closest('.slide-block') || null;
  }

  function updateCard(card, product, meta) {
    if (!card || !product || !meta) return;
    var image = product.featured_image || (product.images && product.images[0]);
    var variant = product.variants && product.variants[0];
    var imageWrap = card.querySelector('.content-wrapper');
    if (imageWrap && image) imageWrap.style.background = 'url(' + image + ')';

    var hiddenImg = card.querySelector('img.tif-visually-hidden');
    if (hiddenImg) hiddenImg.setAttribute('alt', meta.title);

    var heading = card.querySelector('.slide-text h3');
    if (heading) heading.textContent = meta.title;

    var subtitle = card.querySelector('.slide-text .subtitle');
    if (subtitle) subtitle.textContent = meta.subtitle;

    var price = card.querySelector('.bbf-collection-card-price');
    if (!price) {
      price = document.createElement('p');
      price.className = 'bbf-collection-card-price';
      var anchor = subtitle || heading;
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(price, anchor.nextSibling);
    }
    if (price && variant) {
      price.innerHTML = '<span class="money">' + formatDhs(variant.price) + '</span>' +
        (variant.compare_at_price && variant.compare_at_price > variant.price
          ? ' <span class="bbf-collection-card-compare money">' + formatDhs(variant.compare_at_price) + '</span>'
          : '');
    }

    var list = card.querySelector('.slide-text ul');
    if (list) list.innerHTML = meta.features;

    var links = card.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i += 1) {
      links[i].setAttribute('href', product.url);
      var hidden = links[i].querySelector('.tif-visually-hidden');
      if (hidden) hidden.textContent = meta.title + ' ';
    }
  }

  function unslickMobile(slider) {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    if (window.jQuery && jQuery.fn && jQuery.fn.slick && jQuery(slider).hasClass('slick-initialized')) {
      jQuery(slider).slick('unslick');
    }
  }

  function applyFallback() {
    if (applied || !isBottleWarmingCollection()) return;
    ensureStyles();
    var slider = document.querySelector('.product-slider .slider');
    if (!slider || !window.fetch) return;
    unslickMobile(slider);

    Promise.all(Object.keys(productMap).map(function (handle) {
      return fetch('/products/' + handle + '.js').then(function (response) { return response.json(); });
    })).then(function (products) {
      var keys = Object.keys(productMap);
      var firstCard = slider.querySelector(':scope > .slide-block');

      for (var i = 0; i < keys.length; i += 1) {
        var handle = keys[i];
        var card = findCard(slider, handle);
        if (!card && handle === 'superfast-portable-warmer-instant-water-warmer-bundle' && firstCard) {
          card = firstCard.cloneNode(true);
          slider.appendChild(card);
        }
        updateCard(card, products[i], productMap[handle]);
      }

      applied = true;
      unslickMobile(slider);
    }).catch(function () {});
  }

  applyFallback();
  document.addEventListener('DOMContentLoaded', applyFallback);
  window.addEventListener('load', applyFallback);
  setTimeout(applyFallback, 250);
  setTimeout(applyFallback, 1000);
})();

/* PDP price sync from current variant CRO data */
(function () {
  function formatAed(cents) {
    var value = (parseInt(cents, 10) || 0) / 100;
    return 'Dhs. ' + value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function textCents(el) {
    if (!el) return null;
    var match = (el.textContent || '').replace(/,/g, '').match(/[0-9]+(?:\.\d+)?/);
    return match ? Math.round(parseFloat(match[0]) * 100) : null;
  }

  function syncPdpPriceFromCro() {
    var root = document.querySelector('.cro-product-incentives');
    var priceEl = document.getElementById('ProductPrice');
    if (!root || !priceEl) return;
    var price = parseInt(root.getAttribute('data-cro-price'), 10) || 0;
    var compare = parseInt(root.getAttribute('data-cro-compare'), 10) || 0;
    if (!price) return;
    if (textCents(priceEl) !== price) {
      priceEl.textContent = formatAed(price);
      priceEl.setAttribute('bucks-init', (price / 100).toFixed(2));
    }
    var compareEl = document.getElementById('ComparePrice');
    var compareWrap = compareEl ? compareEl.closest('.compare-at') : null;
    if (compare > price) {
      if (compareEl) {
        compareEl.textContent = formatAed(compare);
        compareEl.setAttribute('bucks-init', (compare / 100).toFixed(2));
      }
      if (compareWrap) compareWrap.hidden = false;
    } else if (compareWrap) {
      compareWrap.hidden = true;
    }
    if (window.bbfEnsureCurrencyConverted) {
      window.bbfEnsureCurrencyConverted(priceEl, price);
      if (compareEl && compare > price) window.bbfEnsureCurrencyConverted(compareEl, compare);
    } else if (window.buckscc && typeof window.buckscc.convertPage === 'function') {
      window.buckscc.convertPage();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncPdpPriceFromCro);
  } else {
    syncPdpPriceFromCro();
  }
  window.addEventListener('load', syncPdpPriceFromCro);
  setTimeout(syncPdpPriceFromCro, 300);
  setTimeout(syncPdpPriceFromCro, 1200);
})();

